import { eventHasRun } from '../../utils/eventTracker';
import isValidUrlPath from '../../utils/isValidUrlPath';
import isEmpty from '../../utils/isEmpty';

export const DDC_DIALOG_AJAXCONTENTLOADED = 'ddc.dialog.ajaxContentLoaded';

// Fires when ajax content loads from ajaxDialogComplete or slideOpen document level events
function ajaxContentLoaded(
	{ DDC: { dialogs } },
	{ timeStamp },
	name,
	path,
	$content
) {
	let eventObject;
	if (
		!eventHasRun(DDC_DIALOG_AJAXCONTENTLOADED, {
			timeStamp
		})
	) {
		let $element = $content;
		let hasForm = false;

		if ($element) {
			hasForm = $element.find('form').length > 0;
		} else if (dialogs && (name || isValidUrlPath(path))) {
			$element = dialogs?.[name] || dialogs?.[path];
			hasForm =
				($element &&
					!isEmpty($element) &&
					$element.find('form').length > 0) ||
				false;
		}

		if (hasForm) {
			$element.find('form').attr('data-modal', true);
		}

		eventObject = {
			eventType: DDC_DIALOG_AJAXCONTENTLOADED,
			eventData: {
				element: $element,
				hasForm,
				name: name || '',
				path
			}
		};
	}

	return eventObject;
}

export default ajaxContentLoaded;
